module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Helpful Hints"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Helpful Hints ")])])])])]), _c('div', {
    staticClass: "orderedlist"
  }, [_c('ol', {
    staticClass: "orderedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Extra uses for ramen flavor packets: ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Add to water while preparing any noodle or rice for extra flavor ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Use instead of bouillon—add 1 packet for every 2 cups of water ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Use to flavor gravy—stir into pan drippings along with flour or whisk in\n            water for use instead of stock ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Shake and bake for potatoes ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cutlet, chop, and fish coating—mix 1 packet per 2 tablespoons of flour for\n            coating ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Mix with bread crumbs for frying ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Season ground meat for burgers, meatballs, and meat loaf—mix 1 packet per\n            pound of ground meat ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Seasoning rubs for chicken, steaks, and pork chops ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Check ramen packaging for vegetarian or vegan manufacturers. Just because it is\n            labeled as vegetable ramen does not mean animal products were not used in the\n            manufacturing process. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The ramen noodles are finished cooking when they turn yellow and begin to separate. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Do not overcook ramen noodles. They will become mush. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Salt lovers beware. Taste before throwing in those extra dashes—the\n            seasoning packets are salty. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("To reduce fat and calories, substitute reduced-fat foods such as skim milk, light\n            or fat-free sour cream, and light or fat-free cream cheese. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 clove garlic equals 1 teaspoon minced garlic. This is much more cost effective\n            than bottled minced garlic. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1/4 cup fresh minced onion equals 2 tablespoons dried minced onion. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1/4 cup fresh herbs equals 1 tablespoon dried herbs. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Fresh or frozen vegetables, steamed, can be substituted for canned vegetables. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e30",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("As always, be creative! Most ingredients can be adjusted to your own liking.\n        ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c97806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 72
// module chunks = 0